import * as Yup from 'yup';

// export const addressSchema = (t) =>
//   Yup.object({
//     value: Yup.object({
//       country_code: Yup.string().optional(),
//       full_address: Yup.string().required(),
//       location: Yup.object({
//         latitude: Yup.number().required(),
//         longitude: Yup.number().required(),
//       }).required(),
//       country: Yup.string().optional(),
//       state_province: Yup.string().optional(),
//       city: Yup.string().optional(),
//       street: Yup.string().optional(),
//       post_code: Yup.string().optional(),
//     }),
//     label: Yup.string().required(),
//   }).required(t('required_text'));

export const addressSchema = (t) =>
  Yup.object().required(t('required_text')).nullable();

export const validationSchema = (t) => {
  const addToExchangeSchema = Yup.object({
    country_id: Yup.object().required(t('required_text')),
    transport_bodytype_ids: Yup.array().min(1, t('required_text')).required(t('required_text')),
    transports_loading_types: Yup.array().typeError(' '),
    length: Yup.number().typeError(' '),
    width: Yup.number().typeError(' '),
    height: Yup.number().typeError(' '),
    volume: Yup.number().typeError(' '),
    trailer_registration_number: Yup.string().max(13, `${t('registration.maxLength')}13`),
    loading_address: addressSchema(t),
    unloading_address: addressSchema(t),
    available_from: Yup.date().required(t('required_text')).typeError(t('must_be_date')),
    available_to: Yup.date().required(t('required_text')).typeError(t('must_be_date')),
  });

  return addToExchangeSchema;
};
